module.exports = __webpack_public_path__ + "files/f722d4d6d132784fb37ce13fb1ac3394.png";